module.exports = __webpack_public_path__ + "static/media/visa-logo.0f3d92a2.png";